import React from 'react';
import { Link } from 'react-router-dom';
import ExploreHero from './ExploreHero';
import QuickFactsBar from './QuickFactsBar';
import DiscoverySection from './DiscoverySection';
import FaqAccordion from './FaqAccordion';
import PlanCompletionPanel from '../booking/PlanCompletionPanel';
import TouristWayfinder from '../shared/TouristWayfinder';
import ContentAdSlot from '../shared/ContentAdSlot';
import '../../styles/explore.scss';
import '../../styles/tourist-nav.scss';

function KnowledgeHubLayout({
	seo,
	hero,
	quickFacts,
	intro,
	children,
	faqs,
	cta,
	touristSection,
	touristCurrent,
	planStepId,
	hideRelated = false,
	planBookingPanel = false,
}) {
	return (
		<div className={`explore-page${touristSection ? ' tourist-page' : ''}`}>
			{seo}
			{touristSection && touristSection !== 'plan' && (
				<TouristWayfinder
					section={touristSection}
					currentLabel={touristCurrent || hero.title}
					planStepId={planStepId}
				/>
			)}
			<ExploreHero
				image={hero.image}
				eyebrow={hero.eyebrow}
				title={hero.title}
				lead={hero.lead}
				compact
			/>
			{quickFacts && <QuickFactsBar facts={quickFacts} />}
			<div className="explore-body">
				{intro && (
					<DiscoverySection title={intro.title} intro={intro.text}>
						{intro.body && (
							<p style={{ fontSize: '1.05rem', lineHeight: 1.75, color: '#3d4554', maxWidth: '68ch' }}>
								{intro.body}
							</p>
						)}
					</DiscoverySection>
				)}
				<ContentAdSlot layout="hub" />
				{children}
				{faqs && faqs.length > 0 && (
					<DiscoverySection eyebrow="Common questions" title="Frequently asked questions" alt>
						<FaqAccordion items={faqs} />
					</DiscoverySection>
				)}
				{planBookingPanel && (
					<div className="container">
						<PlanCompletionPanel />
					</div>
				)}
				{!hideRelated && cta && (
					<section className="discovery-section">
						<div className="container">
							<div className="explore-cta-band">
								<h3>{cta.title}</h3>
								<p>{cta.text}</p>
								<Link to={cta.to} className="explore-hero__cta explore-hero__cta--primary">{cta.label}</Link>
							</div>
						</div>
					</section>
				)}
			</div>
		</div>
	);
}

export default KnowledgeHubLayout;
